import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "./contexts/AuthContext";
import UserPage from "./pages/UserPage";

// Same shape as PrivateRoute, plus a role check. Users with a valid token but
// without the "Super Admin" role see the existing 403 screen instead of the
// protected page — no redirect, so the URL stays put and the message is clear.
const SuperAdminRoute = ({ element: Component, ...rest }) => {
  const { token, role, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="loading-data">
        <p>Loading...</p>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/log-in" />;
  }

  if (role !== "Super Admin") {
    return <UserPage />;
  }

  return <Component {...rest} />;
};

export default SuperAdminRoute;
